import { NgModule } from '@angular/core';
//import { IonicPageModule } from 'ionic-angular';
//import { SystemModule } from '../../../../../system/system.module';
//import { SharedModule } from '../../../../../shared/shared.module';
import { WithdrawalFastAccessComponent } from './withdrawal-fastaccess';
import { ServicesSharedModule } from 'src/app/services/services-shared.module';
import { ComponentsModule } from 'src/app/components/components.module';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
    declarations: [
      WithdrawalFastAccessComponent
    ],
    imports: [
        ServicesSharedModule,
        CommonModule,
        IonicModule,
        FormsModule,
        ReactiveFormsModule,
        ComponentsModule
    ],
    exports: [
      WithdrawalFastAccessComponent
    ]
})
export class WithdrawalFastAccessPageModule {}
